var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.items,"label":_vm.label,"rules":_vm.rules},model:{value:(_vm.etapaLead),callback:function ($$v) {_vm.etapaLead=$$v},expression:"etapaLead"}})}
var staticRenderFns = []

export { render, staticRenderFns }